var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("span", { staticClass: "detail-item-label" }, [
      _vm._v("Voting situation :"),
    ]),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("el-progress", {
          staticClass: "common-progress",
          attrs: { percentage: _vm.percentage, "show-text": false },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "spaceBetween" }, [
      _c("span", { staticClass: "text-num" }, [
        _c("span", { staticClass: "text-num-desc" }, [_vm._v("Cumulative")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-bold" },
          [
            _c("big-number", { attrs: { number: _vm.cumulative } }),
            _vm._v(" "),
            _c("span", [_vm._v("UNIT")]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "text-num text-right" }, [
        _c("span", { staticClass: "text-num-desc" }, [_vm._v("Threshold")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-bold" },
          [
            _c("big-number", { attrs: { number: _vm.threshold } }),
            _vm._v(" "),
            _c("span", [_vm._v("UNIT")]),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }